export enum SainAction {
	SOURCE_CLICKED = 'sourceLinkClicked',
	POSITIVE_FEEDBACK_PROVIDED = 'positiveFeedbackProvided',
	NEGATIVE_FEEDBACK_PROVIDED = 'negativeFeedbackProvided',
	DWELL_REACHED = 'dwellTimeReached',
	COPY_CLICKED = 'copyButtonClicked',
	FOLLOWUP_CLICKED = 'followupLinkClicked',
	ERROR_STATE_SUGGESTED_QUERY_CLICKED = 'errorStateSuggestedQueryClicked',
	OPEN_CHAT_CLICKED = 'openChatButtonClicked',
	EXPAND_CLICKED = 'expandButtonClicked',
	READ_MORE_BUTTON_CLICKED = 'readMoreButtonClicked',
	TOPIC_CLICKED = 'topicClicked',
	RECENT_WORK_CLICKED = 'recentWorkClicked',
	COLLABORATOR_CLICKED = 'collaboratorClicked',
	VIEW_PROFILE_CLICKED = 'viewProfileClicked',
	TEAM_MEMBER_CLICKED = 'teamMemberClicked',
	TEAM_LIST_CLICKED = 'teamListClicked',
	TEAM_LIST_ITEM_CLICKED = 'teamListItemClicked',
	VIEW_TEAM_PAGE_CLICKED = 'viewTeamPageClicked',
	REPORTING_LINES_CLICKED = 'reportingLinesClicked',
	PERSON_SELECTED = 'cardClicked',
	BOOKMARK_CLICKED = 'bookmarkClicked',
	CHAT_CLICKED = 'chatClicked',
	JIRA_ISSUE_CLICKED = 'jiraIssueCardClicked',
	VIEW_ALL_SOURCES = 'viewAllSourcesClicked',
	JIRA_NL_TO_JQL_CLICKED = 'jiraNlToJqlCardClicked',
	JIRA_NL_TO_JQL_VIEW_ALL = 'viewAllButtonClicked',
	JIRA_NL_TO_JQL_WORK_ITEM_CLICKED = 'workItemClicked',
	SHOW_ON_GOOGLE_MAPS_CLICKED = 'showOnGoogleMapsClicked',
	TOPIC_KNOWLEDGE_CARD_CLICKED = 'topicKnowledgeCardClicked',
	NAVIGATIONAL_SEARCH_RESULT_CARD = 'navigationalSearchResultCardClicked',
	FMP_DWELL_START = 'fmpDwellStart',
	FMP_DWELL_START_EXPANDED = 'fmpDwellStartExpanded',
	FMP_DWELL_REACHED = 'fmpDwellReached',
	FMP_RESULT_EXITED = 'fmpDwellExited',
	AI_MODE_FOLLOWUP_CLICKED = 'aiModeFollowupLinkClicked',
	SHOW_MORE_TOPICS_CLICKED = 'showMoreTopicsClicked',
	DEFINITION_DWELL_MARKED = 'definitionDwellMarked',
	BLUE_LINK_CLICKED = 'blueLinkClicked',
	THIRD_PARTY_MESSAGE_CLICKED = 'thirdPartyMessageClicked',
	HIERARCHY_NODE_CLICKED = 'hierarchyNodeClicked',
	PROFILE_TAB_CLICKED = 'profileTabClicked',
	PROFILE_SECTION_CLICKED = 'profileSectionClicked',
}
